import {Box, Grid, Stack} from "@mui/material";
import React, {useMemo} from "react";
import {formatEntry} from "../../MetricsDashboard/Utilities/DataTeaser";
import {formatNumber} from "../../MetricsDashboard/Utilities/helpers/metrics.helper";

export default function StatsItem({	label, entry, descriptionChildren }) {
    const formattedValue = useMemo(() => {
        return formatNumber(formatEntry(entry));
    }, [entry])

    return(
        <Grid item xs={4} md={1}>
            <Stack>
                <Box component={'h4'} sx={styles.label}>{label}</Box>
                <Box component={'h3'} sx={styles.value}>{formattedValue}</Box>
                {descriptionChildren && (
                    <Box sx={styles.description}>
                        {descriptionChildren}
                    </Box>
                )}
            </Stack>
        </Grid>
    )
}

const styles = {
    label: {
        m: 0,
        fontSize: '15px',
        fontFamily: 'FustatSemiBold',
        letterSpacing: '0.02em',
        textTransform: 'capitalize',
        mb: '10px'
    },
    value: {
        mt: { xs: 1, md: 1.5 },
        mb: { xs: 0, md: 2.5 },
        fontSize: { xs: '40px', md: '48px' },
        fontFamily: 'FustatSemiBold'
    },
    description: {
        fontFamily: 'FustatMedium',
        fontSize: '14px'
    }
}